// @flow

import reducers from './reducers';
import fetchSettings, {
  dispatchReceivedSettings,
  receivedSettings,
  type ReceivedSettings,
} from './actions';
import getSettings from './selectors/getSettings';

export {
  dispatchReceivedSettings,
  fetchSettings,
  getSettings,
  receivedSettings,
};
export type {
  ReceivedSettings,
};
export {
  needsLoading,
  isFetching,
} from './selectors';
export { GET_SETTINGS_SUCCESS } from './constants';
export type { Settings } from './selectors/getSettings';
export type { State } from './state';
export default reducers;
